import React from 'react'

const FashionApparelsIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 480 480"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        d="M92 428c-13.232 0-24 10.768-24 24v16h64.2c1.952-25.48 22.32-45.84 47.8-47.8V332h-56v64c0 17.648-14.352 32-32 32z"
                        style={{}}
                        fill="#00d3e1"
                        data-original="#00d3e1"
                        className=""
                    />
                    <path
                        d="M140.2 468H180v-39.8c-21.072 1.912-37.888 18.728-39.8 39.8z"
                        style={{}}
                        fill="#00d3e1"
                        data-original="#00d3e1"
                        className=""
                    />
                    <path
                        d="M372 164h64v32h-64z"
                        style={{}}
                        fill="#ffe4b6"
                        data-original="#ffe4b6"
                    />
                    <path
                        d="M60 96h8v196h166.888l9.168-52.688A3.987 3.987 0 0 1 248 236h4v-32h-4c-2.208 0-4-1.792-4-4v-40c0-2.208 1.792-4 4-4h4V96h8v60h48V72c0-33.088-26.912-60-60-60h-6.344l-78.832 78.832c-.776.776-1.8 1.168-2.824 1.168s-2.048-.392-2.832-1.168L78.344 12H72c-33.088 0-60 26.912-60 60v124h48V96zm92 164h16v8h-16v-8zm-32 0h16v8h-16v-8zm-32 0h16v8H88v-8zM324 164h40v32h-40z"
                        style={{}}
                        fill="#00d3e1"
                        data-original="#00d3e1"
                        className=""
                    />
                    <path
                        d="M182.344 12h-44.688L160 34.344z"
                        style={{}}
                        fill="#ffe4b6"
                        data-original="#ffe4b6"
                    />
                    <path
                        d="m251.368 244-31.432 180.68.056 43.32h50.352l30.136-30.136 39.704-127.056c1.048-3.344 6.592-3.344 7.64 0l39.704 127.056L417.664 468H468v-44l-31.368-180H251.368z"
                        style={{}}
                        fill="#ff8242"
                        data-original="#ff8242"
                        className=""
                    />
                    <path
                        d="M252 196h64v-32h-64z"
                        style={{}}
                        fill="#ffe4b6"
                        data-original="#ffe4b6"
                    />
                    <path
                        d="M230.344 12h-36.688l-30.832 30.832c-.776.776-1.8 1.168-2.824 1.168s-2.048-.392-2.832-1.168L126.344 12H89.656L160 82.344 230.344 12z"
                        style={{}}
                        fill="#ff8242"
                        data-original="#ff8242"
                        className=""
                    />
                    <path
                        d="M60 452c0-17.648 14.352-32 32-32 13.232 0 24-10.768 24-24v-64H68v64c0 17.648-14.352 32-32 32-13.232 0-24 10.768-24 24v16h48v-16z"
                        style={{}}
                        fill="#00d3e1"
                        data-original="#00d3e1"
                        className=""
                    />
                    <path
                        d="M8 208h48v88c0 4.416 3.576 8 8 8h164.752L208.12 422.632c-.08.448-.12.904-.12 1.368v48c0 4.416 3.576 8 8 8h56c2.128 0 4.16-.84 5.656-2.344l32-32a7.952 7.952 0 0 0 1.976-3.272L344 338.824l32.368 103.568a8.056 8.056 0 0 0 1.976 3.272l32 32A7.99 7.99 0 0 0 416 480h56c4.424 0 8-3.584 8-8v-48c0-.464-.04-.92-.12-1.368l-32-184A8 8 0 0 0 440 232H264v-24h176c4.424 0 8-3.584 8-8v-40c0-4.416-3.576-8-8-8H320V72c0-39.696-32.296-72-72-72H72C32.296 0 0 32.304 0 72v128c0 4.416 3.576 8 8 8zm456 216.688V464h-44.688l-28.264-28.264-39.416-126.12c-1.04-3.344-4.128-5.616-7.632-5.616s-6.592 2.272-7.632 5.616l-39.416 126.12L268.688 464H224v-39.312L254.728 248H433.272L464 424.688zM312 192h-56v-24h56v24zm120 0h-56v-24h56v24zm-72-24v24h-32v-24h32zM154.344 45.656C155.904 47.216 157.952 48 160 48s4.096-.784 5.656-2.344L195.312 16h25.376L160 76.688 99.312 16h25.376l29.656 29.656zM147.312 16h25.376L160 28.688 147.312 16zM16 72c0-30.88 25.128-56 56-56h4.688l77.656 77.656C155.904 95.216 157.952 96 160 96s4.096-.784 5.656-2.344L243.312 16H248c30.872 0 56 25.12 56 56v80h-40V96h-16v56c-4.424 0-8 3.584-8 8v40c0 4.416 3.576 8 8 8v24a8 8 0 0 0-7.88 6.632L231.528 288H72V96H56v96H16V72z"
                        style={{}}
                        fill="#120536"
                        data-original="#120536"
                        className=""
                    />
                    <path
                        d="M8 480h176c4.424 0 8-3.584 8-8V328c0-4.416-3.576-8-8-8H64c-4.424 0-8 3.584-8 8v68c0 11.024-8.968 20-20 20-19.848 0-36 16.152-36 36v20c0 4.416 3.576 8 8 8zm136.808-16C148 448.352 160.352 436 176 432.808V464h-31.192zM128 396v-60h48v80.64c-24.472 3.528-43.832 22.888-47.36 47.36H72v-12c0-11.024 8.968-20 20-20 19.848 0 36-16.152 36-36zM16 452c0-11.024 8.968-20 20-20 19.848 0 36-16.152 36-36v-60h40v60c0 11.024-8.968 20-20 20-19.848 0-36 16.152-36 36v12H16v-12zM88 256h16v16H88zM120 256h16v16h-16zM152 256h16v16h-16z"
                        style={{}}
                        fill="#120536"
                        data-original="#120536"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default FashionApparelsIcon